import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { AppShell, RequireAdmin, RequireModule } from "@/components/layout/AppShell";
import { InstallPrompt } from "@/components/common/InstallPrompt";

import Login from "@/pages/auth/Login";
import Signup from "@/pages/auth/Signup";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import Dashboard from "@/pages/Dashboard";
import CRM from "@/pages/crm/CRM";
import Customers from "@/pages/Customers";
import Documents from "@/pages/documents/Documents";
import Receivables from "@/pages/Receivables";
import Inventory from "@/pages/Inventory";
import Demos from "@/pages/demos/Demos";
import Repairs from "@/pages/repairs/Repairs";
import Processing from "@/pages/processing/Processing";
import Profitability from "@/pages/profit/Profitability";
import DemoFeedback from "@/pages/public/DemoFeedback";
import RepairApproval from "@/pages/public/RepairApproval";
import Profile from "@/pages/Profile";
import Analytics from "@/pages/Analytics";
import Staff from "@/pages/Staff";
import Settings from "@/pages/Settings";

export default function App() {
  return (
    <ThemeProvider>
      <TooltipProvider delayDuration={200}>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/app/dashboard" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/feedback/:token" element={<DemoFeedback />} />
              <Route path="/estimate/:token" element={<RepairApproval />} />

              <Route path="/app" element={<AppShell />}>
                <Route index element={<Navigate to="/app/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="crm" element={<RequireModule module="crm"><CRM /></RequireModule>} />
                <Route path="customers" element={<RequireModule module="customers"><Customers /></RequireModule>} />
                <Route path="quotations" element={<RequireModule module="quotations"><Documents kind="quotations" /></RequireModule>} />
                <Route path="proformas" element={<RequireModule module="proformas"><Documents kind="proformas" /></RequireModule>} />
                <Route path="invoices" element={<RequireModule module="invoices"><Documents kind="invoices" /></RequireModule>} />
                <Route path="receivables" element={<RequireModule module="invoices"><Receivables /></RequireModule>} />
                <Route path="purchase-orders" element={<RequireModule module="purchase_orders"><Documents kind="purchase-orders" /></RequireModule>} />
                <Route path="inventory" element={<RequireModule module="inventory"><Inventory /></RequireModule>} />
                <Route path="demos" element={<RequireModule module="demos"><Demos /></RequireModule>} />
                <Route path="repairs" element={<RequireModule module="repairs"><Repairs /></RequireModule>} />
                <Route path="processing" element={<RequireModule module="processing"><Processing /></RequireModule>} />
                <Route path="profitability" element={<RequireModule module="profitability"><Profitability /></RequireModule>} />
                <Route path="profile" element={<Profile />} />
                <Route path="analytics" element={<RequireAdmin><Analytics /></RequireAdmin>} />
                <Route path="staff" element={<RequireAdmin><Staff /></RequireAdmin>} />
                <Route path="settings" element={<RequireAdmin><Settings /></RequireAdmin>} />
              </Route>

              <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
            </Routes>
            <Toaster position="top-right" richColors closeButton />
            <InstallPrompt />
          </AuthProvider>
        </BrowserRouter>
      </TooltipProvider>
    </ThemeProvider>
  );
}
